(function () {
    'use strict';

    var app = angular.module('app');

    var myConfig = angular.copy(window.servicesUrl);

    app.config(['commonConfigProvider', function (cfg) {
        cfg.servicesUrl = myConfig;
    }]);
})();